import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Field, useFormikContext } from 'formik';
import { PaymentFormValues } from '@entities/payment';
import { withTheme } from '@shared/lib';
import { OldText, Checkbox } from '@shared/ui/atoms';
import DocumentLink from './DocumentLink';
const CdekMailingAgreementCheckbox: FC = () => {
  const {
    values,
    errors,
    setFieldValue
  } = useFormikContext<PaymentFormValues>();
  return <Field name="isMailingAgreed">
      {({
      field
    }) => <FieldContentWrapper>
          <Checkbox name="isMailingAgreed" size="xs" checked={field.value} hasError={!!errors.isMailingAgreed} onChange={() => setFieldValue('isMailingAgreed', !values.isMailingAgreed)} />
          <OldText>
            Даю{' '}
            <DocumentLink target="_blank" href="https://cdek.shopping/i/46/soglasie-na-polucenie-informacionnoi-i-reklamnoi-rassylki">
              согласие на получение рекламной рассылки
            </DocumentLink>
          </OldText>
        </FieldContentWrapper>}
    </Field>;
};
export default CdekMailingAgreementCheckbox;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const FieldContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FieldContentWrapper",
  class: "f13bts8k",
  propsAsIs: false,
  vars: {
    "f13bts8k-0": [_exp(), "px"],
    "f13bts8k-1": [_exp2(), "px"]
  }
}));

require("./CdekMailingAgreementCheckbox.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CdekMailingAgreementCheckbox.tsx");